var map = {
	"./about.png": 918,
	"./arrow-icon-dark.png": 4806,
	"./arrow-icon.png": 3072,
	"./circular-text.png": 9753,
	"./close-black.png": 4377,
	"./close-white.png": 1984,
	"./code-icon-dark.png": 7778,
	"./code-icon.png": 6209,
	"./dev-icon.png": 712,
	"./download-icon.png": 6532,
	"./edu-icon-dark.png": 1501,
	"./edu-icon.png": 6108,
	"./figma.png": 3333,
	"./firebase.png": 7013,
	"./footer-bg-color.png": 5359,
	"./git.png": 2505,
	"./graphics-icon.png": 2713,
	"./hand-icon.png": 1221,
	"./header-bg-color.png": 2701,
	"./hero-profile.png": 7433,
	"./logo.png": 8505,
	"./logo_dark.png": 7852,
	"./mail_icon.png": 9113,
	"./mail_icon_dark.png": 4555,
	"./menu-black.png": 6421,
	"./menu-white.png": 1620,
	"./mobile-icon.png": 8972,
	"./mongodb.png": 6584,
	"./moon_icon.png": 9701,
	"./profile-img.png": 2134,
	"./project-icon-dark.png": 2043,
	"./project-icon.png": 8749,
	"./react.svg": 8407,
	"./right-arrow-bold-dark.png": 1374,
	"./right-arrow-bold.png": 9105,
	"./right-arrow-dark.png": 5010,
	"./right-arrow-white.png": 8638,
	"./right-arrow.png": 4228,
	"./send-icon.png": 5680,
	"./sun_icon.png": 5210,
	"./ui-icon.png": 7691,
	"./user-image.png": 3351,
	"./vscode.png": 6592,
	"./web-icon.png": 6200,
	"./work-1.png": 167,
	"./work-2.png": 1842,
	"./work-3.png": 9988,
	"./work-4.png": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9771;